export const geolocateSearchLocation = (searchLocation) => fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${searchLocation}&key=${process.env.REACT_APP_GOOGLE_MAP_KEY}`)
    .then((res) => res.json())
    .then((data) => {
        if (!(data && data.results && data.results.length)) {
            return;
        }

        return data.results;
    });
